module.exports = __webpack_public_path__ + "static/media/promo1.99c54eb2.jpg";